/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

/**
 * The dashboard location the palette was opened from.
 */
export type LauncherContext = {
  /**
   * The current dashboard route path.
   */
  route?: string | undefined;
};

/** @internal */
export type LauncherContext$Outbound = {
  route?: string | undefined;
};

/** @internal */
export const LauncherContext$outboundSchema: z.ZodMiniType<
  LauncherContext$Outbound,
  LauncherContext
> = z.object({
  route: z.optional(z.string()),
});

export function launcherContextToJSON(
  launcherContext: LauncherContext,
): string {
  return JSON.stringify(LauncherContext$outboundSchema.parse(launcherContext));
}
